import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useApiList(path, fallback = []) {
  const [items, setItems] = useState(fallback);
  useEffect(() => {
    let live = true;
    api.get(path)
      .then(({ data }) => { if (live && data && data.length > 0) setItems(data); })
      .catch(() => {});
    return () => { live = false; };
  }, [path]); // eslint-disable-line react-hooks/exhaustive-deps
  return items;
}

export function useTestimonials(fallback) {
  return useApiList("/testimonials", fallback);
}

export function useReels(fallback) {
  return useApiList("/reels", fallback);
}

export function useSeasonalTiles(fallback) {
  return useApiList("/seasonal-tiles", fallback);
}
